export default "__VITE_ASSET__oVidS4wr__"